
import './App.css';
import Sidebar from './components/Sidebar';
import Toolbar from './components/Toolbar';
import Sketch from './components/Sketch';
import Model from './components/Model';

function App() {
  return (
    <div className='container'>
      <div className='left-container'>
        <Sidebar />
      </div>
      <div className='right-container'>
        <Toolbar />
        <Sketch />
        <Model />
      </div>
    </div>
  );
}

export default App;
